module.exports = __webpack_public_path__ + "img/shipping_none.6d61cd0f.png";